import React from "react";
import { toast } from "react-toastify";
import tools from "../../../helpers/tools";
import { Pill } from "../../common/DataList";
import { FactList, FicheHeader, copyToClipboard } from "../../common/Fiche";
import SynchroFTStatus from "./SynchroFTStatus";
import EncartAccompagnement from "./SousOrientation/EncartAccompagnement";
import { afficheAccompagnement } from "./SousOrientation/accompagnement";
import {
  buildRecipientEyebrow,
  buildRecipientFacts,
  buildRecipientPills,
  getOrientationSummary,
} from "./recipientFacts";
import { canSeeProcedureActions } from "./RecipientActions";

const RecipientHeader = ({ recipient, constants = {}, orgs = [], back = null, actions = null, role = null, onAccompagnementCorrige }) => {
  const facts = buildRecipientFacts(recipient, { constants });
  const pills = buildRecipientPills(recipient);
  const orientation = getOrientationSummary(recipient, orgs);

  const onCopy = (value) =>
    copyToClipboard(value).then(
      () => toast.success("La valeur a été copiée dans votre presse-papier"),
      () => toast.error("Impossible de copier la valeur")
    );

  return (
    <FicheHeader
      back={back}
      backLabel="Retour à la liste des allocataires"
      eyebrow={buildRecipientEyebrow(recipient, { constants })}
      title={tools.getFullname(recipient) || "Allocataire"}
      pills={pills.map((p) => (
        <Pill key={p.id} tone={p.tone} icon={p.icon}>
          {p.label}
        </Pill>
      ))}
      actions={actions}
    >
      <div>
        <FactList facts={facts} onCopy={onCopy} />
        {!canSeeProcedureActions(recipient) && (
          <p className="fiche-note" role="status">
            <i className="fa fa-info-circle" aria-hidden="true" />
            Réorientation non disponible car une procédure est déjà en cours.
          </p>
        )}
      </div>
      <div className={`fiche-orientation${orientation ? "" : " fiche-orientation--none"}`}>
        <div className="fiche-orientation__label">Orientation</div>
        {orientation ? (
          <>
            <div className="fiche-orientation__value">{orientation.name}</div>
            <div className="fiche-orientation__meta">
              {[orientation.type, orientation.date ? `le ${orientation.date}` : ""].filter(Boolean).join(" · ")}
              {orientation.maintainedAt && ` — maintien le ${orientation.maintainedAt}`}
            </div>
            <div className="fiche-orientation__status">
              <SynchroFTStatus categorie="ORIENTATION" entiteId={orientation.orientationId} />
            </div>
            {recipient.id && afficheAccompagnement(recipient, role) && (
              <EncartAccompagnement
                allocataireId={recipient.id}
                nomAllocataire={tools.getFullname(recipient) || "Allocataire"}
                onCorrigee={onAccompagnementCorrige}
              />
            )}
          </>
        ) : (
          <div className="fiche-orientation__value">Sans orientation</div>
        )}
      </div>
    </FicheHeader>
  );
};

export default RecipientHeader;
